// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_e4-3";
export var flatBottomCorners = "_e4-5";
export var productImage = "_e4-0";
export var quantityContainer = "_e4-2";
export var quantityHeader = "_e4-6";
export var tooltip = "_e4-1";
export var wrapAndEllipsesOverflow = "_e4-4";